import request from "@/utils/request.js"
// 连锁
export const getOrderList=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/chain/try/getOrderList',
    params,
  });
}
export const getNoteDetail=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/chain/try/getNoteDetail',
    params,
  });
}
// 单门店
export const getOrderListStore=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/store/try/getOrderList',
    params,
  });
}
export const getNoteDetailStore=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/store/try/getNoteDetail',
    params,
  });
}


